<div class="modal-overlay" role="dialog" aria-modal="true">

  <div class="modal">
    <button class="close-button" (click)="fecharModal()">
      <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>
    <div class="modal-content">
      <h4> {{ this.title }} </h4>
      <div style="display: flex; flex-direction: column; justify-content: space-evenly; height: 100%;">
        <ng-container *ngIf="this.tipo !== 'IMOVEIS_AREA_MILITAR' ">
          <button class="filter-btn" (click)="clickNavegar('Locação')">Alugar</button>
          <button class="filter-btn" (click)="clickNavegar('Compra')">Comprar</button>
        </ng-container>
        <ng-container *ngIf="this.tipo === 'IMOVEIS_AREA_MILITAR' ">
          <button class="filter-btn" (click)="selectMilitar('IMOVEIS_BASE_AEREA')">Base Aérea</button>
          <button class="filter-btn" (click)="selectMilitar('IMOVEIS_BRIGADA_HOSPITAL')">6a Brigada e Hospital Militar</button>
          <button class="filter-btn" (click)="selectMilitar('IMOVEIS_COLEGIO_MILTAR')">Colégio Militar</button>
          <button class="filter-btn" (click)="selectMilitar('IMOVEIS_AREA_VERDE_QUARTEIS')">Área Verde dos Quartéis</button>

        </ng-container>

      </div>
    </div>

  </div>
</div>